// 중앙도서관 AK,
// 중앙도서관 수정분관 AH,
// 해운대도서관 BD,
// 사하도서관 AE
// 충남아산 아산꿈샘도서관
// 충남아산 배방복합커뮤니티센터도서관
// 충남아산 배방월천도서관
// 충남아산 음봉어울샘도서관

export type LibraryType = "busan" | "asan";
export type AuthType = "klas" | "alpas";

export type Manage_code = "AK" | "AH" | "BD" | "AE" | "CH" | "MC" | "MI" | "MH";

export const libraryConfig = {
  ak: {
    manageCode: "AK",
    type: "busan",
    displayName: "부산광역시중앙도서관",
  },
  ah: {
    manageCode: "AH",
    type: "busan",
    displayName: "부산광역시중앙도서관 수정분관",
  },
  bd: {
    manageCode: "BD",
    type: "busan",
    displayName: "해운대도서관",
  },
  ae: {
    manageCode: "AE",
    type: "busan",
    displayName: "사하도서관",
  },

  "kkoomsaem-lib": {
    manageCode: "CH",
    type: "asan",
    displayName: "충남아산 아산꿈샘도서관",
  },
  "baebang-complex-lib": {
    manageCode: "MC",
    type: "asan",
    displayName: "충남아산 배방복합커뮤니티센터도서관",
  },
  "baebang-wolcheon-lib": {
    manageCode: "MI",
    type: "asan",
    displayName: "충남아산 배방월천도서관",
  },
  "eumbong-eoulsaem-lib": {
    manageCode: "MH",
    type: "asan",
    displayName: "충남아산 음봉어울샘도서관",
  },
} as const;

export const librarys = Object.keys(libraryConfig) as Array<keyof typeof libraryConfig>;

export type Library_code = (typeof librarys)[number];

export const normalizeLibraryCode = (library?: string | null): Library_code | null => {
  if (!library) {
    return null;
  }

  const normalizedLibrary = library.toLowerCase();
  if (!(normalizedLibrary in libraryConfig)) {
    return null;
  }

  return normalizedLibrary as Library_code;
};

export const isLibraryCode = (library?: string | null): library is Library_code => {
  return normalizeLibraryCode(library) !== null;
};

export const libraryTypeMap: Record<Library_code, LibraryType> = Object.fromEntries(
  librarys.map((library) => [library, libraryConfig[library].type])
) as Record<Library_code, LibraryType>;

export const libraryAuthTypeMap: Record<LibraryType, AuthType> = {
  busan: "klas",
  asan: "alpas",
};

export const getManageCodeByLibrary = (library?: string | null): Manage_code | null => {
  const normalizedLibrary = normalizeLibraryCode(library);
  if (!normalizedLibrary) {
    return null;
  }

  return libraryConfig[normalizedLibrary].manageCode;
};

export const getLibraryDisplayName = (library?: string | null) => {
  const normalizedLibrary = normalizeLibraryCode(library);
  if (!normalizedLibrary) {
    return "";
  }

  return libraryConfig[normalizedLibrary].displayName;
};

export const getLibraryTypeByLibrary = (library?: string | null): LibraryType => {
  const normalizedLibrary = normalizeLibraryCode(library);
  if (!normalizedLibrary) {
    return "busan";
  }

  return libraryTypeMap[normalizedLibrary];
};

export const getAuthTypeByLibrary = (library?: string | null): AuthType | null => {
  const normalizedLibrary = normalizeLibraryCode(library);
  if (!normalizedLibrary) {
    return null;
  }

  const libraryType = libraryTypeMap[normalizedLibrary];
  return libraryAuthTypeMap[libraryType];
};

export type libraryParams = {
  library: Library_code;
};
